import React from 'react'
import './family-info-gutter.css'
import ContactInfoTab from './ContactInfoTab/ContactInfoTab'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'
import { getRequestHeaders } from '../../api'
import { MdAutoAwesome } from 'react-icons/md'

const FamilyInfoGutter = ({
    modalInfo,
    setModalInfo,
    setCopyConfirmationPopup,
    setFamilyProfile,
    teachers = [],
    onOpenScheduler,
}) => {
    const [familyInfo, setFamilyInfo] = React.useState({})
    const [loadingFamilyInfo, setLoadingFamilyInfo] = React.useState(true)
    const [hookUpFamily, setHookUpFamily] = React.useState(true)
    const [scheduledEvents, setScheduledEvents] = React.useState([])

    const getFamilyInfo = React.useCallback(async () => {
        setLoadingFamilyInfo(true)
        if(!modalInfo.familyId || modalInfo.familyId === 'none') {
            setHookUpFamily(true)
            setLoadingFamilyInfo(false)
        } else {
            await axios.get(`${baseUrl}/calendar/family/${modalInfo.familyId}`, getRequestHeaders())
            .then(res => {
                setScheduledEvents(res.data)
            })
            .catch(err => console.log(err))
            await axios.get(`${baseUrl}/school-management/${modalInfo.familyId}`, getRequestHeaders())
            .then(res => {
                setLoadingFamilyInfo(false)
                setFamilyProfile(res.data)
                setFamilyInfo(res.data)
                setHookUpFamily(false)
            })
            .catch(err => console.log(err))
        }
    }, [modalInfo.familyId, setFamilyProfile])

    React.useEffect(() => {
        axios.get(`${baseUrl}/teacher-invitations/${modalInfo.familyId}`)
        .catch((err) => console.log(err))

        getFamilyInfo()
    }, [getFamilyInfo, modalInfo.familyId])

    return (
        <div className='family-info-gutter'>
            <button
                type='button'
                className='family-info-gutter__scheduler-button'
                onClick={() => onOpenScheduler && onOpenScheduler()}
            >
                <MdAutoAwesome size={16} aria-hidden='true' />
                Scheduler
            </button>
            <ContactInfoTab
                modalInfo={modalInfo}
                setModalInfo={setModalInfo}
                setCopyConfirmationPopup={setCopyConfirmationPopup}
                familyInfo={familyInfo}
                loadingFamilyInfo={loadingFamilyInfo}
                hookUpFamily={hookUpFamily}
                scheduledEvents={scheduledEvents}
                getFamilyInfo={getFamilyInfo}
                teachers={teachers}
            />
        </div>
    )
}
export default FamilyInfoGutter
